import React from "react";
import {
  Route,
  RouteComponentProps,
  RouteChildrenProps,
} from "react-router-dom";

interface IProps {
  component?:
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>;
  render?: (props: RouteComponentProps<any>) => React.ReactNode;
  children?:
    | ((props: RouteChildrenProps<any>) => React.ReactNode)
    | React.ReactNode;
  path?: string | string[];
  exact?: boolean;
  sensitive?: boolean;
  strict?: boolean;
}

export const PublicRoute: React.FC<IProps> = ({ children, ...rest }) => {
  return <Route {...rest} render={({ location }) => children} />;
};
